// import {
//     // Collapse,
//     // Dropdown,
//     // Alert,
//     // Button,
//     // Carousel,
//     // Modal,
//     // Offcanvas,
//     // Popover,
//     // ScrollSpy,
//     // Tab,
//     // Toast,
//     // Tooltip,
// } from 'bootstrap';

/* Custom SCSS */
// import "./index.scss";
// import './style-login.scss';
// import './style-admin.scss';
// import './style-buttons.scss';

/* Swiper */

import Swiper from "swiper/bundle";
import "swiper/css/bundle";
window.Swiper = Swiper;

// Swiper.use([Scrollbar]);
// init Swiper:

// import swiperSlider from "./js/swiperSlider";
// swiperSlider();

/* Fancybox */

// import { Fancybox } from "@fancyapps/ui";
// import "@fancyapps/ui/dist/fancybox.css";

/* Gsap */

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;

// var Isotope = require('isotope-layout');

import massimo from "./js/massimo";
massimo();

import navbar from "./js/navbar";
navbar();

import footer from "./js/footer";
footer();

import sidebar from "./js/sidebar";
sidebar();

import search from "./js/search";
search();

import realizzazioni from "./js/realizzazioni";
realizzazioni();

// import woocommerce from "./js/woocommerce";
// woocommerce();

import scrollTop from "./js/scrollTop";
scrollTop();

import contactForm from "./js/contactForm";
contactForm();

document.addEventListener('DOMContentLoaded', () => {
    const anchors = document.querySelectorAll('a[href*="#"]')
    if (!anchors.length) return;
    anchors.forEach(anchor => {
        anchor.addEventListener('click', (e) => {
            const hash = anchor.hash;
            if (!hash || hash.length < 2) return;

            // Salta i link che puntano a un'altra pagina
            if (anchor.pathname !== window.location.pathname || anchor.hostname !== window.location.hostname) return;

            const target = document.querySelector(hash);
            if (!target) return;

            e.preventDefault();
            const headerHeight = document.querySelector(".header")?.offsetHeight || 0;
            gsap.to(window, {
                duration: 1.2,
                ease: "power2.inOut",
                scrollTo: { y: target, offsetY: headerHeight },
            });
        })
    })
})